export const state = {
  displayDebugNotification: false,
  debugNotification: null
};

export const mutations = {
  showDebugNotification(state, content) {
    state.displayDebugNotification = true;
    state.debugNotification = content;
  },
  closeDebugNotification(state) {
    state.displayDebugNotification = false;
  }
};

export const actions = {
  showDebugNotification({ commit }, content) {
    commit('showDebugNotification', content);
  },
  closeDebugNotification({ commit }) {
    commit('closeDebugNotification');
  }
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
